import { ApolloProvider } from "@apollo/client";
import { CacheProvider, EmotionCache } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ConfirmProvider } from "material-ui-confirm";
import { SnackbarProvider } from "notistack";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../css/react-dates-overrides.css";
import "@fullcalendar/common/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/list/main.css";
import { ThemeContextProvider } from "@/styles/theme";
import { useApollo } from "@/lib/apolloClient/frontend";
import createEmotionCache from "@/lib/createEmotionCache";
import { ProfileProvider } from "@/components/Auth/ProfileProvider";
import { ChecklistProvider } from "@/contexts/ChecklistContext";
import { MultiSiteProvider } from "@/contexts/MultiSiteContext";
import { OrganizationBrandProvider } from "@/contexts/OrganizationBrandContext";

const clientSideEmotionCache = createEmotionCache();

function MyApp({
  Component,
  emotionCache = clientSideEmotionCache,
  pageProps: { session, ...pageProps },
}: {
  Component: any;
  emotionCache?: EmotionCache;
  pageProps: any;
}) {
  const apolloClient = useApollo(
    typeof pageProps.initialApolloState === "string"
      ? JSON.parse(pageProps.initialApolloState)
      : pageProps.initialApolloState
  );
  let trackingSetupInterval = 0;

  return (
    <CacheProvider value={emotionCache}>
      <ApolloProvider client={apolloClient}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ProfileProvider>
            <OrganizationBrandProvider>
              <ThemeContextProvider>
                <MultiSiteProvider>
                  <ChecklistProvider>
                    <SnackbarProvider maxSnack={3}>
                      {/* @ts-ignore */}
                      <ConfirmProvider>
                        <CssBaseline />
                        <Component {...pageProps} />
                      </ConfirmProvider>
                    </SnackbarProvider>
                  </ChecklistProvider>
                </MultiSiteProvider>
              </ThemeContextProvider>
            </OrganizationBrandProvider>
          </ProfileProvider>
        </LocalizationProvider>
      </ApolloProvider>
    </CacheProvider>
  );
}

export default MyApp;
